import React from 'react';
import { TypeaheadUserComponent } from '../typeahead-user/TypeaheadUser.component';
import WishlistIconYellow from '../../../assets/icons/VARITA_AMARILLA.svg';
import { ITypeaheadButton, ITypeaheadList } from '../../../domain/typeahead.interfaces';
import { EDefaultWishList } from '../../../domain/wish.interface';
import { ERoutes } from '../../../assets/constants/routes';

export function TypeaheadUserPublicComponent(props: any) {

  const openPublicList = (user: any) => {
    const wishlist = user.wishLists.find((w: any) => w.name === EDefaultWishList.MY_WISHES);
    window.location.href = `${process.env.REACT_APP_BASE_URL}${ERoutes.WISH_LIST_PUBLIC.replace(':wishListId', wishlist.locator)}`;
  };

  const buttonsUserConfig: ITypeaheadButton[] = [
    {
      image: WishlistIconYellow,
      action: openPublicList,
    },
  ];

  const onExpandTypeaheadOptions = (userOption: ITypeaheadList) => {
    return [
      { ...userOption, buttons: buttonsUserConfig, onClickAction: openPublicList }
    ];
  };

  return (
    <TypeaheadUserComponent onExpandTypeaheadOptions={onExpandTypeaheadOptions} />
  );
}
